import { DocumentSegment } from "@app/shared/models/documentSegment";
import { Job } from "@app/shared/models/job";
import { Team } from "@app/shared/models/team";
import { OfferActivity } from "@app/shared/models/offerActivity";
import { OfferAllocation } from "@app/shared/models/offerAllocation";
import { OfferType } from "@app/shared/models/offerType";
import { PublicOfferAsset } from "@app/shared/models/publicOfferAsset";
import { PublicOfferExtraInfos } from "@app/shared/models/publicOfferExtraInfos";
import { OfferTemplate } from "@app/shared/models/offerTemplate";
import { Disclaimer } from "@app/shared/models/disclaimer";
export class Offer {
  id?: number;
  advertDetails?:string;
  allocation?:OfferAllocation;
  approvedDate?:number;
  assetkeys?:string;
  callout?:string;
  code?:string;
  comments?:string;
  compPriceUnit?:string;
  contentUnitUom?:string;
  createdDate?:number;
  customData?:any;
  dateLastUpdated?:number;
  publicDecorationAssets?:PublicOfferAsset[];
  department?:string;
  discountType?:string;
  domain?:string;
  endDate?:number;
  extraNotes?:string;
  extraText?:string;
  fromSavings:string;
  groupName?:string;
  gstAmountString?:string;
  leaseBuyPlanDetails?:string;
  localOffer?:string;
  locale?:string;
  logoText?:string;
  loyaltyProgramInfo?:string;
  minSpend?:string;
  multiBuyQuantity?:string;
  netContent?:string;
  offerActivities?:OfferActivity[];
  offerDescr?:string;
  offerName?:string;
  offerTypeDescr?:string;
  offerTypeOriginal?:string;
  offeringestionbatchid?:string;
  offeringestionbatchofferid?:string;
  offerViews?:OfferTemplate;
  onsaleFriday?:string;
  onsaleMidweek?:string;
  origOfferReference?:string;
  origXml?:string;
  packagedOffer?:string;
  packagedOfferDiscountValue?:string;
  pageIn?:string;
  position?:string;
  previousDate?:number;
  previousDateString?:string;
  previousPrice?:number;
  region?:string;
  rejectedDate?:number;
  retiredDate?:number;
  salesIndication?:string;
  saveCurrency?:string;
  saveString?:string;
  saveCombined?:string;
  savingsType?:string;
  segmentNumber?:string;
  sellCurrency?:string;
  sellDecoration?:string;
  sellString?:string;
  sellCombined?:string;
  snippet?:string;
  startDate?:number;
  status?:string;
  studioTrigger?:string;
  tactic?:string;
  tags?:string;
  termType?:string;
  toSavings:string;
  unit?:string;
  unitPrice?:number;
  uuid:string;
  viewBuildFlag?:string;
  viewBuildType?:string;
  publicOfferAssets?:any[];
  publicOfferExtraInfos?:any[];
  disclaimers?:Disclaimer[];
  sales_indication?:string;
  percentOff?:string;
  discountValue?:number;
  wasDate?:number;
  team?:Team;
  lockStatus?:string;
  allocationId?:string;
  pageUUID?:string;
  heroAssetMediaURL?:string;
  offerTypeId?:string;
  offerViewThumb?:string;
  offerViewPreview?:string;
  offerViewSvg?:string;
  offerType?:OfferType;
  heroAssetMediaPreviewURL?:string;
  heroSaveStatement?:string;

  get isLocked():boolean{
    return this.lockStatus === "T"?true:false;
  }
  get isVendor():boolean{
    return ((this.offerType && this.offerType.name.toLowerCase() === 'vendor') || (this.offerTypeDescr && this.offerTypeDescr.toLowerCase() === 'vendor'))?true:false;
  }

}

export class OfferMenuEvent{
  type?:string;
  offer?:Offer;
  documentSegment?:DocumentSegment;
  job?:Job;
  allocation?:OfferAllocation;
  isDrop?:boolean;
  custom?:any;
}

export const OfferMenuEventType = {
  EDIT_OFFER: 'EDIT_OFFER',
  ADD_OFFER: 'ADD_OFFER',
  LOCK_OFFER:'LOCK_OFFER',
  DELETE_OFFER:'DELETE_OFFER',
  ADD_TO_FAVE:'ADD_TO_FAVE',
  ALLOC_OFFER:'ALLOC_OFFER',
  UNALLOC_OFFER:'UNALLOC_OFFER',
  ASSIGN_OFFER:'ASSIGN_OFFER',
  COPY_OFFER:'COPY_OFFER',
  OFFER_HISTORY:'OFFER_HISTORY',
  REMOVE_TEMPLATE:'REMOVE_OFFER_TEMPLATE',
  MOVE_OFFER:'MOVE_OFFER',
  SWAP_OFFERS:'SWAP_OFFERS',
};


export const OfferActionTypeDesc = {
  'ADD OFFERVIEW': 'created an offer view',
  'ADD OFFER': 'created the offer',
  'EDIT OFFER': 'edited the offer',
  'MOVE OFFER': 'moved the offer',
  'ADD FAVOURITE OFFER': 'add the offer as a favourite',
  'SWAP OFFER': 'swapped the offer',
  'COPY OFFER':'copied the offer',
  'ASSIGN OFFER TO PAGE': 'assigned the offer to a page',
  'ASSIGN OFFER TO ALLOCATION':'assigned the offer to an allocation',
  'LOCK OFFER' : 'locked the offer',
  'UNLOCK OFFER' : 'unlocked the offer',
  'UNALLOCATE OFFER' : 'unallocated the offer',
  'REMOVE FAVOURITE OFFER' : 'removed the offer as a favourite',
  'ASSIGN FAVOURITE OFFER': 'assigned favourite offer',
  'ASSIGN FAVOURITE OFFER TO DIFFERENT JOB': 'assigned favourite offer to a different job',
  'EDIT ASSET DECORATION': 'updated the asset decoration',
  'EDIT ASSET MEDIA': 'updated the asset media',
  'EDIT ASSET PRODUCT': 'updated the asset product',
  'ADD ASSET MEDIA':'added a media asset',
  'ADD ASSET PRODUCT':'added a product asset',
  'ADD ASSET DECORATION':'added a decoration asset',
  'REMOVE ASSET MEDIA':'removed a media asset',
  'REMOVE ASSET PRODUCT':'removed a product asset',
  'REMOVE ASSET DECORATION':'removed a decoration asset',
  'COPY ASSET MEDIA':'copied an asset media',
  'COPY ASSET DECORATION':'copied an asset decoration',
  'COPY ASSET PRODUCT':'copied as asset product',
  'SEND OFFER TO STUDIOS':'offer sent to studios',
};



export class OfferSearchCriteria{
  keyword?:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/offer.ts